import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { BehaviorSubject, Observable, firstValueFrom } from "rxjs";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TableApiCredentialsService {

  // @ts-ignore
  private _products$ = new BehaviorSubject<table[]>([]);
  private _total$ = new BehaviorSubject<number>(0);
  get products$() { return this._products$.asObservable(); }
  get total$() { return this._total$.asObservable(); }

  constructor(private http: HttpClient) {
  }

  getAccountMulti() {
    return this.http.get<{ accounts: any[]; total: number }>(
      `${environment.apiUrl}/getaccountkeymulti`
    );
  }

  switchAccount(accountId: string) {
    return this.http.put<any>(`${environment.apiUrl}/accountKeymulti`, {
      accountId
    });
  }

}
